import { objectToQueryString } from '@helper/utils'

export default {
  computed: {
    parameter_filter () {
      return this.$store.state.filter.parameter_filter
    }
  },
  methods: {
    async fetchParams (params, routeName) {
      try {
        // return if request from /tutor-suggestion page
        if (this.$route.name === 'tutor-suggestion') {
          return
        }
        if (this.emitData) {
          this.$emit('paramsUpdated', { ...params, zn_city: { name: this.city, id: params.zn_city_id }, course_tree: { id: params.course_id } })
        } else {
          const { link_parameters } = await this.$store.dispatch('filter/getLinkParameters', params)
          const query = { ...this.$route?.query, teaching_type: params?.teaching_type.toUpperCase() }
          this.$router.push(this.localePath(`/${this.$routeName[routeName]}/${this.joinParams(link_parameters)}?${objectToQueryString(query)}`))
        }
      } catch (error) {
        this.$logger.captureException({ error })
      }
    },
    joinParams (link_parameters) {
      if (!link_parameters || !link_parameters.length) { return '' }
      return link_parameters.map(l => l).join('/')
    },
    arrayParamsToObjParams (link_parameters) {
      if (!link_parameters || !link_parameters.length) { return '' }

      const params = link_parameters
      const obj = {}

      params.forEach((element, index) => {
        obj['param' + (index + 1)] = element
      })

      return obj
    },
    setParams (value) {
      const course = {
        course_id: value.course_id,
        course_group_id: value.course_group_id
      }
      if (course.course_id) {
        delete course.course_group_id
      }
      const teacher_gender = value.teacher_gender
      const filterParams = {
        link_parameters: {
          ...course,
          zn_city_id: value.zn_city_id
        },
        query: {
          teaching_type: value.teaching_type,
          teacher_stars: value.teacher_stars,
          teacher_gender
        }
      }
      if (!teacher_gender) {
        delete filterParams.query.teacher_gender
      }
      this.$store.commit('filter/SET_PARAMS_FILTER', filterParams)
    },
    async filter (isNewParams = false) {
      try {
        this.$store.commit('filter/SET_LOADING_LIST', true)
        if (isNewParams) {
          const { link_parameters } = await this.$store.dispatch('filter/getLinkParameters', { ...this.parameter_filter.link_parameters })
          await this.$store.dispatch('filter/getTeachers', {
            params: link_parameters,
            query: { ...this.parameter_filter.query }
          })
        } else {
          await this.$store.dispatch('filter/getTeachers', {
            params: this.$store.state.filter.link_parameters,
            query: { ...this.parameter_filter.query }
          })
        }
        this.setToTop()
      } catch (e) {
        this.$logger.captureException({ error: e })
      } finally {
        this.$store.commit('filter/SET_LOADING_LIST', false)
      }
    }
  }
}
